import { Component, Input, OnInit } from '@angular/core';
import * as fromDataServices from '../../data-services';
import { LoggingService } from '../../shared/services/logging/logging.service';

@Component({
    selector: 'ef-reconciliation',
    templateUrl: './reconciliation.component.html',
    styleUrls: ['./reconciliation.component.scss'],
    standalone: false
})
export class ReconciliationComponent implements OnInit {
    @Input() items: fromDataServices.Reconciliation.ReconciliationModel[];
    constructor(private log: LoggingService) {}

    ngOnInit(): void {}

}
